'use strict';

module.exports = {
  listen: function(node, e, fn) {
    if (node.addEventListener) {
      node.addEventListener(e, fn, false); 
    } else if (node.attachEvent)  {
      node.attachEvent('on' + e, fn);
    }
  },
  unlisten: function(node, e, fn) {
    if (node.removeEventListener) {
      node.removeEventListener(e, fn, false); 
    } else if (node.attachEvent)  {
      node.detachEvent('on' + e, fn);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/events.js
// module id = 15
// module chunks = 1 3